import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'
import {NinchatTagDeletedEvent} from '../types/events'

export const tagDeleted: CaseReducer<NinchatState> = (state, action) => {
    const {
        realm_id,
        tag_id,
        tag_attrs,
        ...rest
    } = extractProperties<NinchatTagDeletedEvent>(action.payload)

    isEmpty(rest)

    if (realm_id) {
        const {parent_id} = tag_attrs

        if (parent_id) {
            delete state._tags[realm_id][parent_id].tag_children[tag_id]
        } else {
            delete state._tags[realm_id][tag_id]
        }
    }
}
